import { IFilterPrimitive } from '@/interfaces/filters.interfaces';

import instanceOfPrimitive from './instanceOfPrimitive';
import isObject from './isObject';

function instanceOfFilterPrimitive(object: any): object is IFilterPrimitive {
  return isObject(object) && 'value' in object && instanceOfPrimitive(object?.value);
}

export default instanceOfFilterPrimitive;
